import PanTool from '@mui/icons-material/PanTool';
import ThumbDown from '@mui/icons-material/ThumbDown';
import { Tooltip } from '@mui/material';
import { orange } from '@mui/material/colors';
import { createElement } from 'react';

export function getComplementoTitleImpedimento(numerosProcessos) {
    return numerosProcessos.length === 1 ? 'no processo' : 'nos processos';
}

export function filtrarImpedimentosMagistrado(magistrado, impedimentos, situacaoImpedimento) {
    return (impedimentos || []).filter(
        (impedimento) =>
            impedimento.magistrado.sigla === magistrado.sigla &&
            impedimento.magistrado.cpf === magistrado.cpf &&
            (!situacaoImpedimento || impedimento.situacaoImpedimento === situacaoImpedimento)
    );
}

export function getIconeImpedimentoPossivel(numerosProcessos) {
    return createElement(
        Tooltip,
        {
            slotProps: { popper: { style: { zIndex: 9_999_999 } } },
            title:
                'Possível impedimento ' +
                getComplementoTitleImpedimento(numerosProcessos) +
                ': ' +
                numerosProcessos.join('; '),
            placement: 'top'
        },
        createElement(
            'div',
            null,
            createElement(ThumbDown, {
                style: { padding: '8px', fillOpacity: 0.7, color: orange[900], transform: 'scaleX(-1)' }
            })
        )
    );
}

export function getIconeImpedimentoDeclarado(numerosProcessos) {
    return createElement(
        Tooltip,
        {
            slotProps: { popper: { style: { zIndex: 9_999_999 } } },
            title:
                'Impedimento declarado ' +
                getComplementoTitleImpedimento(numerosProcessos) +
                ': ' +
                numerosProcessos.join('; '),
            placement: 'top'
        },
        createElement(
            'div',
            null,
            createElement(PanTool, { style: { padding: '8px', fillOpacity: 0.7, color: orange[900] } })
        )
    );
}

export function getIconeImpedimentoDeclaradoMagistrado(magistrado, impedimentos) {
    const declarados = filtrarImpedimentosMagistrado(magistrado, impedimentos, 'IMPEDIMENTO_DECLARADO');

    if (declarados.length > 0) {
        return createElement(
            'div',
            { style: { display: 'flex' } },
            getIconeImpedimentoDeclarado(declarados.map((impedimento) => impedimento.numeroProcesso))
        );
    }
}

export function getIconeImpedimentoPossivelMagistrado(magistrado, impedimentos) {
    const possiveis = filtrarImpedimentosMagistrado(magistrado, impedimentos, 'IMPEDIMENTO_POSSIVEL');

    if (possiveis.length > 0) {
        return getIconeImpedimentoPossivel(possiveis.map((impedimento) => impedimento.numeroProcesso));
    }
}

export function getIconesImpedimentoMagistrado(magistrado, impedimentos) {
    const iconePossivel = getIconeImpedimentoPossivelMagistrado(magistrado, impedimentos);
    const iconeDeclarado = getIconeImpedimentoDeclaradoMagistrado(magistrado, impedimentos);

    if (iconePossivel || iconeDeclarado) {
        return createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'center' } },
            createElement('span', { style: { width: '40px' } }, iconePossivel),
            createElement('span', { style: { width: '40px' } }, iconeDeclarado)
        );
    }
}

export function aplicarIconesImpedimento(opcoes, impedimentos) {
    return opcoes.map((opcao) => {
        if (!opcao.valor?.sigla) return opcao;

        const icone = getIconesImpedimentoMagistrado(opcao.valor, impedimentos);

        return icone ? { ...opcao, icone, cor: orange[900] } : opcao;
    });
}

export function getOpcoesMagistrados(dominioStore, impedimentos) {
    return aplicarIconesImpedimento(dominioStore.opcoesMagistradosAutoComplete(), impedimentos);
}

export function filtrarOpcoesDisponiveis(
    opcoes,
    composicao,
    localizacaoUsuario,
    { considerarSubstitutos = true } = {}
) {
    const shouldPermitirSiglaCS = localizacaoUsuario === 'CSJT';

    return opcoes.filter(({ valor }) => {
        if (!shouldPermitirSiglaCS && valor.sigla.startsWith('CS')) {
            return false;
        }

        return !composicao.some(({ magistrado }) => {
            if (!magistrado.sigla) {
                return false;
            }

            return (
                magistrado.sigla === valor.sigla ||
                (considerarSubstitutos &&
                    (magistrado.siglaSubstituto === valor.sigla || magistrado.nome === valor.nome))
            );
        });
    });
}

export function getOpcaoMagistrado(magistradoPadrao, opcoesMagistrados) {
    return (
        magistradoPadrao.titular &&
        opcoesMagistrados.find(
            (opcaoMagistrado) =>
                opcaoMagistrado.valor.sigla === magistradoPadrao.titular.sigla &&
                opcaoMagistrado.valor.cpf === magistradoPadrao.titular.cpf
        )
    );
}

export function getComposicaoPadraoSessao(sessaoStore, opcoesMagistrados) {
    const composicao = [];
    // eslint-disable-next-line unicorn/consistent-boolean-name
    let jaMarcouPresidente = false;
    if (sessaoStore.sessaoSelecionada && sessaoStore.sessaoSelecionada.composicaoPadrao) {
        for (const magistradoPadrao of sessaoStore.sessaoSelecionada.composicaoPadrao) {
            const opcaoMagistrado = getOpcaoMagistrado(magistradoPadrao, opcoesMagistrados);

            if (opcaoMagistrado) {
                composicao.push({
                    magistrado: {
                        ...opcaoMagistrado.valor,
                        presidenteSessao: jaMarcouPresidente ? false : magistradoPadrao.presidenteSessao,
                        ausente: false
                    }
                });

                if (magistradoPadrao.presidenteSessao) {
                    jaMarcouPresidente = true;
                }
            }
        }
    }
    return composicao;
}
